import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy URL from the first contractor-access iteration (PHO-11282); the
// Agreements page moved back under /admin/sales/agreements, which handles
// auth for both admins and contractors.
export const Route = createFileRoute('/_app/internal/agreements')({
    beforeLoad: () => {
        throw redirect({ to: '/admin/sales/agreements', replace: true });
    },
    component: () => null,
});
